import CircularImage from '@creator/ui/components/CircularImage/CircularImage';
import type { ImageProps } from '@creator/ui/components/Image/Image';
import { cn } from '@creator/ui/utils/ui';
import EosImg from '@src/assets/images/eos.png';
import EthImg from '@src/assets/images/eth.png';
import anonymouseProfileImg from '@src/assets/images/profile.png';
import { useStoreState } from '@src/model/hooks';
import { getTokenIcon } from '@src/model/token/helpers';
import { storeEqualityFn } from '@src/utils/object-utils/object-utils';
import { noop } from '@src/utils/utils';
import type { FC } from 'react';

export interface TokenImageProps {
    className?: string;
    tokenName: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    isLoading?: boolean;
}

const TokenImage: FC<TokenImageProps> = props => {
    const { onClick = noop, tokenName, className, isLoading } = props;

    const token = useStoreState(state => state.token.getToken(tokenName), storeEqualityFn);

    function getImageClassName(): string {
        const base = 'shrink-0 shadow w-10 h-10';
        return base;
    }

    function getImageProps(): ImageProps {
        const props: ImageProps = {
            src: getImageSrc(),
            fallbackSrc: getFallbackImageSrc(),
            className: cn(getImageClassName(), className),
            isLoading,
            onClick,
        };

        // attach SSR marker attribute; ImageProps doesn't declare data-* attributes
        props['data-ssr'] = 'token-image';

        return props;
    }

    function getImageSrc(): string {
        if (tokenName === 'ETH') return EthImg;
        if (tokenName === 'EOS') return EosImg;
        if (token && !token.imageURI) return getFallbackImageSrc();
        if (token?.imageURI) return token.imageURI;

        return getTokenIcon(tokenName);
    }

    function getFallbackImageSrc(): string {
        return anonymouseProfileImg;
    }

    return <CircularImage imageProps={getImageProps()} />;
};

export default TokenImage;
